module.exports = __webpack_public_path__ + "assets/56149f23685e883c2e0830100bbb16b2.mp3";